module.exports = __webpack_public_path__ + "img/slide6.35370dcd.png";